/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Hazards-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 2019-09-17
 * Copyright All Rights Reserved
 */
import { IN_PROGRESS, COMPLETE } from 'constants/reportStatuses';

export const inProgress = status => status === IN_PROGRESS;

export const isComplete = status => status === COMPLETE;

